export const LinemenPositions = ['OL', 'DL', 'LT', 'LG', 'C', 'RG', 'RT', 'DE', 'DT', 'NT', 'EDGE', 'RE', 'LE', 'RDE', 'LDE', 'RDT', 'LDT', 'NG', 'N', 'T', 'G', 'ED', 'EDG'] as const;

export type LinemenPosition = typeof LinemenPositions[number];